// extracted by mini-css-extract-plugin
export default {"link":"link-button_link__qyOTM","disabled":"link-button_disabled__rzIEV"};